module.exports = __webpack_public_path__ + "img/gadgets.5c6a7e94.jpg";